import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar as opções de preço da Revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @param {boolean} enabled - Indica se a query deve ser executada.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 * A resposta é um array de objetos.
 */
export function fetchPrecoRevenda({
  enabled,
  authToken,
}: {
  enabled?: boolean;
  authToken: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/RevendaPreco";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.get(url, config);
    return response?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-preco"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}
